export default {"src":"/_next/static/media/bed-and-breakfast.4808bee8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};